export default {
  isReligion: false,
}
